
import React from "react";
import { useNavigate } from "react-router-dom";

const modules = [
  {
    title: "Администратор",
    description: "Управление системой, сотрудниками и настройками",
    icon: "⚙️",
    path: "/calendar",
  },
  {
    title: "Менеджер по закупкам",
    description: "Поиск товаров, поставщики и закупки в Китае",
    icon: "🛒",
    path: "/procurement",
  },
  {
    title: "Менеджер по клиентам",
    description: "Клиенты, коммуникация и работа с заказами",
    icon: "👥",
    path: "/client-manager",
  },
];

function DesktopPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-full bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <h1 className="text-3xl font-semibold text-gray-900">
            Рабочий стол
          </h1>

          <p className="mt-2 text-gray-500">
            Выберите рабочий модуль
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {modules.map((module) => (
            <button
              key={module.title}
              onClick={() => navigate(module.path)}
              className="
                group
                text-left
                bg-white
                rounded-2xl
                border
                border-gray-200
                p-6
                shadow-sm
                hover:shadow-md
                hover:border-gray-300
                transition-all
                duration-200
              "
            >
              <div
                className="
                  w-16
                  h-16
                  rounded-2xl
                  bg-gray-100
                  flex
                  items-center
                  justify-center
                  text-3xl
                  mb-5
                  group-hover:bg-gray-200
                  transition-colors
                "
              >
                {module.icon}
              </div>

              <h2 className="text-xl font-semibold text-gray-900">
                {module.title}
              </h2>

              <p className="mt-2 text-sm text-gray-500 leading-6">
                {module.description}
              </p>

              <div className="mt-6 text-sm font-medium text-gray-700">
                Открыть →
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DesktopPage;
